/* Standard product media only; Shopify variants remain owned by bs-product. */
(function () {
  'use strict';
  const storefront = window.BSStorefront;
  if (storefront.productMagnifier) return;
  storefront.productMagnifier = { unregister: storefront.lifecycle.register('bs-product-magnifier', '[data-bs-product]', function(root) {
  const mainImg = root.querySelector('#mainProductImage');
  const glass = root.querySelector('#magnifierGlass');

  if (!mainImg || !glass) return;

  const supportsFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!supportsFinePointer) {
    glass.style.visibility = 'hidden';
    return;
  }


  let disposed = false;
  const cleanup = [], probes = new Set();
  const active = () => !disposed && root.isConnected !== false;
  function listen(target, type, handler, options) {
    const guarded = event => { if (active()) handler(event); };
    target.addEventListener(type, guarded, options);
    cleanup.push(() => target.removeEventListener(type, guarded, options));
  }
  function release() {
    disposed = true;
    cleanup.splice(0).forEach(remove => remove());
    probes.forEach(image => { image.onload = image.onerror = null; });
    probes.clear();
    pendingSources.forEach(entry => entry.resolve(null));
    pendingSources.clear();
  }

  const zoom = 2.6;
  let version = 0;
  let rafId = null;
  let pendingEvent = null;
  let currentZoomSrc = null;
  const preloadedSources = new Set();
  const pendingSources = new Map();
  let hovering = false;

  const canMagnify = () => {
    return !mainImg.classList.contains('bs-spin-enabled') || mainImg.dataset.interactionMode === 'magnify';
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const preloadZoomImage = (src) => {
    if (!src || preloadedSources.has(src)) return Promise.resolve(src);
    if (pendingSources.has(src)) return pendingSources.get(src).promise;
    let resolve;
    const promise = new Promise(done => { resolve = done; });
    pendingSources.set(src, { promise, resolve });
    const img = new Image();
    probes.add(img);
    let completed = false;
    const finish = success => {
      if (completed) return;
      completed = true;
      probes.delete(img); img.onload = img.onerror = null;
      pendingSources.delete(src);
      if (success && active()) preloadedSources.add(src);
      resolve(success && active() ? src : null);
    };
    img.onload = () => finish(true);
    img.onerror = () => finish(false);
    img.decoding = 'async';
    img.src = src;
    return promise;
  };

  const refreshLensBackground = () => {
    if (!active() || !canMagnify()) return;
    const requestVersion = ++version;
    const zoomSrc = mainImg.dataset.zoomSrc || mainImg.currentSrc || mainImg.src;
    const fallbackSrc = mainImg.currentSrc || mainImg.src;
    const imageRect = mainImg.getBoundingClientRect();

    // Show the already-displayed image immediately to avoid white flash,
    // then swap to the high-res zoom source once it has loaded.
    const initialSrc = preloadedSources.has(zoomSrc) ? zoomSrc : fallbackSrc;
    currentZoomSrc = initialSrc;
    glass.style.backgroundImage = `url('${initialSrc}')`;
    glass.style.backgroundRepeat = 'no-repeat';
    glass.style.backgroundSize = `${imageRect.width * zoom}px ${imageRect.height * zoom}px`;

    if (hovering && zoomSrc && zoomSrc !== initialSrc) {
      preloadZoomImage(zoomSrc).then((loaded) => {
        if (!active() || requestVersion !== version) return;
        if (loaded && glass.style.visibility === 'visible') {
          const rect = mainImg.getBoundingClientRect();
          currentZoomSrc = loaded;
          glass.style.backgroundImage = `url('${loaded}')`;
          glass.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;
        } else if (loaded) {
          currentZoomSrc = loaded;
        }
      });
    }
  };

  const moveLens = (event) => {
    if (!canMagnify()) {
      glass.style.visibility = 'hidden';
      return;
    }

    const imageRect = mainImg.getBoundingClientRect();
    const lensRect = glass.getBoundingClientRect();
    const lensHalfWidth = lensRect.width / 2;
    const lensHalfHeight = lensRect.height / 2;
    const pointerX = event.clientX - imageRect.left;
    const pointerY = event.clientY - imageRect.top;
    const maxX = imageRect.width - lensHalfWidth / zoom;
    const maxY = imageRect.height - lensHalfHeight / zoom;
    const minX = lensHalfWidth / zoom;
    const minY = lensHalfHeight / zoom;
    const x = clamp(pointerX, minX, maxX);
    const y = clamp(pointerY, minY, maxY);

    glass.style.left = `${x - lensHalfWidth}px`;
    glass.style.top = `${y - lensHalfHeight}px`;
    glass.style.backgroundPosition = `-${x * zoom - lensHalfWidth}px -${y * zoom - lensHalfHeight}px`;
    glass.style.visibility = 'visible';
  };

  const queueMoveLens = (event) => {
    if (!canMagnify()) return;
    pendingEvent = { clientX: event.clientX, clientY: event.clientY };

    if (rafId !== null) {
      return;
    }

    rafId = requestAnimationFrame(() => {
      rafId = null;

      if (!active() || !pendingEvent) {
        return;
      }

      moveLens(pendingEvent);
      pendingEvent = null;
    });
  };

  function hide() {
    glass.style.visibility = 'hidden';
    if (rafId !== null) cancelAnimationFrame(rafId);
    rafId = null; pendingEvent = null; version++;
  }

  try {
  listen(mainImg, 'mouseenter', () => {
    hovering = true;
    if (!canMagnify()) {
      glass.style.visibility = 'hidden';
      return;
    }

    refreshLensBackground();
  });

  listen(mainImg, 'mousemove', (event) => {
    queueMoveLens(event);
  });

  listen(glass, 'mousemove', (event) => {
    queueMoveLens(event);
  });

  listen(mainImg, 'mouseleave', () => {
    hovering = false;
    hide();
  });

  listen(mainImg, 'pointerdown', () => {
    if (mainImg.classList.contains('bs-spin-enabled') && mainImg.dataset.interactionMode !== 'magnify') {
      glass.style.visibility = 'hidden';
    }
  });

  listen(root, 'bs:product-media-change', () => { hovering = false; hide(); });
  listen(root, 'bs:product-media-mode', () => { hovering = false; hide(); });
  listen(mainImg, 'error', hide);
  listen(mainImg, 'load', refreshLensBackground);

  listen(window, 'resize', () => {
    if (glass.style.visibility === 'visible') {
      refreshLensBackground();
    }
  });

  refreshLensBackground();
  } catch (error) { hide(); release(); throw error; }
  return function dispose() { hide(); release(); preloadedSources.clear(); currentZoomSrc = null; };
  }) };
})();
